@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.form {
    align-items: center;
    border-bottom: 1px solid rgb(var(--color-black-base), 0.25);
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 24px;
}

.heading {
    font-size: 2rem;
    line-height: 1;
    text-transform: uppercase;
    width: 100%;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        font-size: 1.25rem;
    }
}

.lineBreak::before {
    content: " ";
    display: block;
}

// Screenreader only - Hide label visually
.label {
    clip-path: inset(50%);
    display: block;
    height: 1px;
    overflow: hidden;
    position: absolute;
    width: 1px;
}

.input {
    border: 1px solid rgb(var(--color-black-base), 0.25);
    border-radius: 5px;
    box-shadow: 1px 1px 3px rgb(var(--color-black-base), 0.25) inset;
    color: rgb(var(--color-black-base), 0.5);
    display: inline-block;
    font-size: 1rem;
    font-weight: 700;
    padding: 0.5rem 0.5rem 0.5rem 20px;
    position: relative;
    vertical-align: top;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        width: 50%;
    }
}

.button {
    composes: roundButton from "../../styles/buttons.module.scss";
    padding: 9px 20px 8px;
    font-size: 1.25rem;
}
